import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getAccountRtgsPayments,
  getAccountRtgsPayment,
  createAccountRtgsPayment,
  updateAccountRtgsPayment,
  deleteAccountRtgsPayment,
  completeAccountRtgsPayment,
} from "api/accountRtgsPaymentApi"

export const ACCOUNT_RTGS_PAYMENT_QUERY_KEY = "account-rtgs-payments"

export const useAccountRtgsPayments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_RTGS_PAYMENT_QUERY_KEY,
    getAccountRtgsPayments,
    params,
    enabled
  )
}

export const useAccountRtgsPayment = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_RTGS_PAYMENT_QUERY_KEY, getAccountRtgsPayment, id, enabled)
}

export const useCreateAccountRtgsPayment = () => {
  return useCreateResource(createAccountRtgsPayment, ACCOUNT_RTGS_PAYMENT_QUERY_KEY)
}

export const useEditAccountRtgsPayment = () => {
  return useEditResource(updateAccountRtgsPayment, ACCOUNT_RTGS_PAYMENT_QUERY_KEY)
}

export const useDeleteAccountRtgsPayment = () => {
  return useDeleteResource(deleteAccountRtgsPayment, ACCOUNT_RTGS_PAYMENT_QUERY_KEY)
}

export const useCompleteAccountRtgsPayment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: completeAccountRtgsPayment,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ACCOUNT_RTGS_PAYMENT_QUERY_KEY] }),
  })
}
